









































































































import { login } from "@/api/Login";
import { UserProfile } from "@/api/dto/UserProfile";
import Vue, { PropType } from "vue";
export default Vue.extend({
  name: "Footer",
  props: {
    loginData: Object as PropType<UserProfile>,
  },
});
